import React, { Component } from 'react'
import SupplierApi from '../../../api/Purchase/Suppliers'
import { withRouter } from 'react-router-dom'
import { pick } from 'lodash'
import SupplierRegistrationApproval from '../../../components/Purchasing/SupplierRegistration/SupplierRegistrationApproval'
import { message, notification } from 'antd'
import MembersApi from '../../../api/Members'
import BanksApi from '../../../api/Banks'
import DocumentsApi from '../../../api/Documents'

class SupplierRegistrationApprovalCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      fetching: false,
      current: 0,
      fetchingSupplier: false,
      listExist: [],
      lastActionIsNext: true,
      memberType: null,
      bankType: null,
      RepType: null,
      member: null,
      bank: null,
      rep: null,
    }
  }

  api = new SupplierApi()
  membersApi = new MembersApi()
  banksApi = new BanksApi()
  docsApi = new DocumentsApi()

  key = this.props.match.params.key
  memberRef = React.createRef()
  bankRef = React.createRef()
  refRef = React.createRef()
  refAccountRef = React.createRef()
  refLogisticRef = React.createRef()

  contractRef = React.createRef()

  async componentDidMount() {
    await this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({ fetching: true })

      const list = await this.api.registrations.get(this.key)
      const members = await this.membersApi.organisationFull()
      const reps = await this.membersApi.individual()

      let listExist = {
        members,
        banks: {},
        reps,
      }

      this.setState({ list, listExist, fetching: false })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }

  fetchBank = async (owner) => {
    this.setState({ fetching: true })
    const banks = await this.banksApi.list(owner)
    let listExist = this.state.listExist
    listExist.banks = banks
    this.setState({ banks, listExist, fetching: false })
  }

  next = async () => {
    // same index as in SupplierRegistrationForm steps deceleration
    try {
      if (this.state.current === 1) {
        const formMember = await this.checkForm(this.memberRef)
        // console.log(formMember)
        this.setState({ formMember })
      }

      if (this.state.current === 2) {
        const contractRep = await this.checkForm(this.contractRef)
        // console.log(contractRep)
        this.setState({ contractRep })
      }

      if (this.state.current === 4) {
        const formBank = await this.checkForm(this.bankRef)
        // console.log(formBank)
        this.setState({ formBank })
      }

      if (this.state.current === 6) {
        const formRep = await this.checkForm(this.refRef)
        console.log(66, formRep)
        this.setState({ formRep })
      }

      if (this.state.current === 8) {
        const formAccRep = await this.checkForm(this.refAccountRef)
        console.log(88, formAccRep.accounts)
        this.setState({ formAccRep: formAccRep.accounts })
      }

      if (this.state.current === 10) {
        const formLogisticRep = await this.checkForm(this.refLogisticRef)
        console.log(10, formLogisticRep.coordinator)
        this.setState({ formLogisticRep: formLogisticRep.coordinator })
      }
    } catch (e) {}

    const current = this.state.current + 1
    this.setState({ current, lastActionIsNext: true })
  }

  skip = () => {
    const current = this.state.current + 2
    this.setState({ current })
  }
  prev = () => {
    // if (this.state.current === 1) {
    //   this.setState({ member: null })
    // }
    //
    // if (this.state.current === 3) {
    //   this.setState({ bank: null })
    // }
    //
    // if (this.state.current === 5) {
    //   this.setState({ rep: null })
    // }

    const current = this.state.current - 1
    this.setState({ current, lastActionIsNext: false })
  }

  setMember = (member, type) => {
    this.setState({ member, memberType: type })
  }

  setBank = (bank, type) => {
    this.setState({ bank, bankType: type })
  }

  setRep = (rep, type) => {
    console.log('-------------------')
    console.log(33, { rep, type })
    console.log('-------------------')
    switch (type) {
      case 'representative':
        console.log('setRep', { type, rep })
        this.setState({ rep, RepType: type })
        break
      case 'accounts':
        console.log('setRep', { type, rep })
        this.setState({ accountsRep: rep, RepType: type })
        break
      case 'logistics':
        console.log('setRep', { type, rep })
        this.setState({ logisticsRep: rep, RepType: type })
        break
    }
  }

  setSameRep = (rep, type) => {
    switch (type) {
      case 'representative':
        console.log('setSameRep', { type, rep })
        this.setState({ rep, RepType: type })
        break
      case 'accounts':
        console.log('setSameRep', { type, rep })
        this.setState({ accountsSameRep: rep, RepType: type })
        break
      case 'logistics':
        console.log('setSameRep', { type, rep })
        this.setState({ logisticsSameRep: rep, RepType: type })
        break
    }
  }

  getData = () => {
    const dataEditedMember = this.state.formMember
    const dataEditedBank = this.state.formBank
    const { representativeContact } = this.state.formRep || {}

    const accountsRep = this.state.accountsSameRep || this.state.formAccRep
    const logisticsRep = this.state.logisticsSameRep || this.state.formLogisticRep

    const dataEditedContract = this.state.formRep
    console.log(99, {
      representativeContact,
      accountsRep,
      logisticsRep,
    })

    // data from form
    let dataEdited = {
      ...dataEditedMember,
      ...dataEditedBank,
      ...dataEditedContract,
      representativeContact,
      accountsRep,
      logisticsRep,
    }

    dataEdited.business = {
      ...dataEditedMember?.business,
      ...dataEditedContract?.business,
    }

    let dataExist = {
      member: this.state.member,
      bank: this.state.bank,
      rep: this.state.rep,
      accountsRep: this.state.accountsRep,
      logisticsRep: this.state.logisticsRep,
    }
    // sent data
    return {
      dataExist,
      dataEdited,
      id: this.state.list._key,
    }
  }

  approve = async () => {
    try {
      this.setState({
        approving: true,
      })

      const data = this.getData()

      const res = await this.api.registrations.approve(data)

      this.props.history.push(`/purchasing/suppliers/${res._key}/#contracts`)
      notification['info']({
        message: 'Please Create The Contract',
        description:
          'The Account has not been created, you have to do it manually, ' +
          'Please press "+ New" Button in Accounts Tab',
        duration: 10,
      })
      this.setState({
        approving: false,
      })
      message.success('Approved !')
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        approving: false,
      })
    }
  }

  checkForm = (currentRef) => {
    return new Promise((res, rej) => {
      currentRef.current.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }

  render() {
    console.log(44, this.getData())

    return (
      <SupplierRegistrationApproval
        {...this.state}
        {...pick(this, [
          'onCancel',
          'setSameRep',
          'onEdit',
          'submit',
          'update',
          'remove',
          'fetch',
          'skip',
          'checkForm',
          'approve',
          'handleOps',
          'refAccountRef',
          'refLogisticRef',
          'next',
          'prev',
          'setMember',
          'setBank',
          'setRep',
          'memberRef',
          'bankRef',
          'refRef',
          'contractRef',
          'getData',
          'fetchBank',
        ])}
      />
    )
  }
}

export default withRouter(SupplierRegistrationApprovalCont)
